import axios from "axios";
import { baseURL } from "../config/config";

const http = axios.create({
  baseURL,
  timeout: 5000, // 设置请求超时时间
});

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 比如添加 token 到请求头
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
const request = (method, url, dataOrParams = {}, config = {}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method,
      url,
      ...config,
    };

    // 如果是 GET 请求，将参数放在 params 中
    if (method.toLowerCase() === "get") {
      requestConfig.params = dataOrParams;
    } else {
      requestConfig.data = dataOrParams;
    }

    http(requestConfig)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export { request };
